function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0304Ico03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.57 73.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63.21,44.77c-5.66,0-10.25-4.59-10.25-10.25s4.59-10.25,10.25-10.25,10.25,4.59,10.25,10.25-4.59,10.25-10.25,10.25ZM52.07,47.76c0,4.22-3.42,7.64-7.64,7.64s-7.64-3.42-7.64-7.64,3.43-7.64,7.64-7.64,7.64,3.42,7.64,7.64ZM33.88,72.81v-5.35c0-4.94,4.72-7.76,10.55-7.76s10.55,2.83,10.55,7.76v5.35M80.9,72.81v-10.32c0-8.28-7.92-13.02-17.69-13.02-3.73,0-5.64.67-5.64.67M73.95,22.79c-1.08-8.4-14.45-11.08-21.82-12.37-8.44-1.48-13.16-5.32-16.03-7.32-2.19-1.53-3.64-2.53-5.16-1.74-2.13,1.09-3.41,4.49-2.94,7.74.35,2.39,1.96,6.79,8.76,9.37.12.05.25.1.37.16l-26.72,3.95c-2.87.42-5.64,3.16-5.1,6.85.23,1.6,1.07,3,2.36,3.96,1.3.96,2.89,1.36,4.49,1.13l16.48-2.42-22.41,3.32c-2.88.42-5.63,3.2-5.09,6.9.49,3.29,3.55,5.57,6.84,5.09l22.92-3.36-19.67,2.89c-2.87.42-5.64,3.16-5.1,6.84.24,1.59,1.1,3.08,2.39,4.04,1.3.96,2.89,1.36,4.48,1.13l19.89-2.92-11.92,1.75c-2.67.4-5.24,2.95-4.74,6.38.45,3.07,3.32,5.27,6.37,4.83l6.73-.99M89.53,10.58s-12.72,5.72-17.91,7.42M101.5,47.77l-19.38,6.19",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.15px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0304Ico03);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-04-ico-03.1b50aef43827b70e3942c468ddb20f24.svg";
export { ForwardRef as ReactComponent };